import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Notification Panel Store — Story 92.1 Task 3.
 *
 * Owns the open/closed flag for the notification panel. The actual panel UI
 * is built in Story 92.2; 92.1 only owns the toggle state and drives the
 * `BellIcon`'s open/closed visual state from `isOpen`.
 *
 * Module Federation rule: shared-domain consumers MUST import via
 * `@helios/shared-domain/stores/notificationPanelStore` (not relative paths).
 */
interface NotificationPanelStore {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const useNotificationPanelStore = create<NotificationPanelStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      toggle: () => set((s) => ({ isOpen: !s.isOpen }), false, 'notificationPanel/toggle'),
      open: () => set({ isOpen: true }, false, 'notificationPanel/open'),
      close: () => set({ isOpen: false }, false, 'notificationPanel/close'),
    }),
    { name: 'notificationPanelStore' }
  )
);
